export default __webpack_public_path__ + "static/media/divider.f54535c7.svg";